import React from 'react'
import sideImg from './images/Graphic-side-img.jpg'

export default function Graphic_web_dev_ser() {
  return (
    <>
      <div className="container graphic-contain-section-main">
        <div className="row row-cols-2 graphic-row">
            <div className="col graphic-col">
                <div className="main-heading-graphic">
                    <h1>
                    What Sets Our Design Services Apart
                    </h1>
                </div>
                <div className="main-para-graphic">
                    <p>
                    We offer fast, high-quality graphic design solutions through a clear and efficient subscription model. Our tech-driven approach streamlines the entire process—from creative briefing to final delivery—ensuring consistency, speed, and scalability.
                    </p>
                    <p>
                    Backed by proprietary tools and a skilled team, we efficiently handle large volumes of design work, making us the preferred partner for high-growth teams and top brands. Ready to upgrade how your organization handles design? Book a call today and experience the difference.
                    </p>
                </div>
                <div className="heading-button">
                        <div className="button-design">
                            <h4>Share Your Project</h4>
                        </div>
                    </div>

            </div>
            <div className="col big-img-side">
                <div className="img-section">
                    <img src={sideImg} alt="" />
                </div>

            </div>
        </div>
      </div>
    </>
  )
}
